import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AuthorizeGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const pathUrl = state.url;

    const pathContain = (pathName) => {
      if (pathUrl.includes(pathName)) {
        return pathUrl;
      }
    };

    if (pathContain('central-parcel')) {
      if (pathContain("equipment") && this.authService.isAllowedToGrantSubsystem(1, 1)) {
        return true;
      }
      if (pathContain("land-and-building") && this.authService.isAllowedToGrantSubsystem(1, 2)) {
        return true;
      }
      this.router.navigate(['/dashboard']);
      return false;
    }

    if (pathContain('general-info')) {
      if (pathContain("equipment-type") && this.authService.isAllowedToGrantSubsystem(3, 3)) {
        return true;
      }
      if (pathContain("main-parcel-type") && this.authService.isAllowedToGrantSubsystem(3, 4)) {
        return true;
      }
      if (pathContain("sub-parcel-type") && this.authService.isAllowedToGrantSubsystem(3, 5)) {
        return true;
      }
      if (pathContain("unit-type") && this.authService.isAllowedToGrantSubsystem(3, 6)) {
        return true;
      }
      this.router.navigate(['/dashboard']);
      return false;
    }

    if (pathContain('user-management')) {
      if (pathContain("permission-group") && (this.authService.isAllowedToGrantSubsystem(2, 7) || this.authService.isAdmin)) {
        return true;
      }
      if (pathContain("user") && (this.authService.isAllowedToGrantSubsystem(2, 8) || this.authService.isAdmin)) {
        return true;
      }
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}